import { render, staticRenderFns } from "./ableAddToClassStudentList.vue?vue&type=template&id=65d67c9c&"
import script from "./ableAddToClassStudentList.vue?vue&type=script&lang=js&"
export * from "./ableAddToClassStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports